/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droppublish1Inputs */

const en_droppublish1 = /** @type {(inputs: Droppublish1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

const de_droppublish1 = /** @type {(inputs: Droppublish1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish" |
*
* @param {Droppublish1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droppublish1 = /** @type {((inputs?: Droppublish1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droppublish1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droppublish1(inputs)
	return de_droppublish1(inputs)
});
export { droppublish1 as "dropPublish" }